import React from 'react';
import { GlobalContainer, InputContainer, Label, Slider, Input } from './style';
const Toggle = ({ onChange, checked, disabled, width, height, translate, backgroundColorChecked, backgroundColorUnchecked, backgroundColorButton, name, value, labelRight, labelLeft, sliderWidth, sliderHeight, }) => {
    return (React.createElement(GlobalContainer, null,
        labelLeft && React.createElement(Label, null, labelLeft),
        React.createElement(InputContainer, { onChange: onChange, width: width, height: height },
            React.createElement(Input, { type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, translate: translate, backgroundColorUnchecked: backgroundColorUnchecked, backgroundColorChecked: backgroundColorChecked }),
            React.createElement(Slider, { sliderWidth: sliderWidth, sliderHeight: sliderHeight, backgroundColorUnchecked: backgroundColorUnchecked, backgroundColorButton: backgroundColorButton })),
        labelRight && React.createElement(Label, null, labelRight)));
};
Toggle.defaultProps = {
    backgroundColorChecked: '#2193F3',
    backgroundColorUnchecked: '#ccc',
    backgroundColorButton: '#fff',
    sliderWidth: 26,
    sliderHeight: 26,
    width: 60,
    height: 34,
    translate: 26,
};
export default Toggle;
